import * as May2024 from "./CKE_P_2024_MAJ";
import * as August2023 from "./CKE_P_2023_SIE";
import * as June2023 from "./CKE_P_2023_CZE";
import * as May2023 from "./CKE_P_2023_MAJ";
import * as May2026 from "./CKE_P_2026_MAJ";
import * as December2022 from "./CKE_P_2022_GRU";
import * as December2023 from "./CKE_P_2023_GRU";
import * as December2024 from "./CKE_P_2024_GRU";
import * as March2026 from "./CKE_P_2026_MAR";
import * as June2026 from "./CKE_P_2026_CZE";
import * as August2025 from "./CKE_P_2025_SIE";
import * as August2026 from "./CKE_P_2026_SIE";
import * as June2025 from "./CKE_P_2025_CZE";
import * as May2025 from "./CKE_P_2025_MAJ";
import * as June2024 from "./CKE_P_2024_CZE";
import * as August2024 from "./CKE_P_2024_SIE";
import * as ExtendedMay2025 from "./CKE_R_2025_MAJ";
import * as ExtendedMay2024 from "./CKE_R_2024_MAJ";
import * as ExtendedDecember2024 from "./CKE_R_2024_GRU";
import * as ExtendedJune2025 from "./CKE_R_2025_CZE";
import * as ExtendedMay2026 from "./CKE_R_2026_MAJ";
import * as ExtendedJune2026 from "./CKE_R_2026_CZE";
import * as ExtendedDecember2022 from "./CKE_R_2022_GRU";
import * as ExtendedMay2023 from "./CKE_R_2023_MAJ";
import * as ExtendedJune2023 from "./CKE_R_2023_CZE";

import * as ExtendedJune2024 from "./CKE_R_2024_CZE";

export const OFFICIAL_MATURA_SHEET_MODULES = Object.freeze({
  "cke-p-2024-maj": May2024,
  "cke-p-2023-sierpien": August2023,
  "cke-p-2023-czerwiec": June2023,
  "cke-p-2023-maj": May2023,
  "cke-p-2022-grudzien": December2022,
  "cke-p-2023-grudzien": December2023,
  "cke-p-2024-grudzien": December2024,
  "cke-p-2026-marzec": March2026,
  "cke-p-2026-czerwiec": June2026,
  "cke-p-2026-sierpien": August2026,
  "cke-r-2024-czerwiec": ExtendedJune2024,
  "cke-r-2023-czerwiec": ExtendedJune2023,
  "cke-r-2023-maj": ExtendedMay2023,
  "cke-r-2022-grudzien": ExtendedDecember2022,
  "cke-r-2026-czerwiec": ExtendedJune2026,
  "cke-r-2024-grudzien": ExtendedDecember2024,
  "cke-r-2026-maj": ExtendedMay2026,
  "cke-r-2025-czerwiec": ExtendedJune2025,
  "cke-r-2024-maj": ExtendedMay2024,
  "cke-r-2025-maj": ExtendedMay2025,
  "cke-p-2026-maj": May2026,
  "cke-p-2025-sierpien": August2025,
  "cke-p-2025-czerwiec": June2025,
  "cke-p-2025-maj": May2025,
  "cke-p-2024-czerwiec": June2024,
  "cke-p-2024-sierpien": August2024,
});

export function getOfficialMaturaSheetModule(sheetId) {
  return OFFICIAL_MATURA_SHEET_MODULES[sheetId] || null;
}
